import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import DetailRepository from '../Repositories/DetailRepository'


class DetailBloc {

    detailChannel = new Subject();
    generateChannel = new Subject();
    generateUndanganSaksiChannel = new Subject();
    generatePegawaiChannel = new Subject();
    generateRohaniawanChannel = new Subject();
    generateSPMTChannel = new Subject();
    docMenghadiriPelantikanChannel = new Subject();
    docSaksiChannel = new Subject();
    invPegawaiChannel = new Subject();
    invRohaniawanChannel = new Subject();
    docSPMTChannel = new Subject();
    inactiveChannel = new Subject();
    repository = new DetailRepository()

    constructor() {
        this.detailChannel.next({status: apiResponse.INITIAL})
    }

    fetchDetail = async (query) => {
        this.detailChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDetail(query).then((result) => {
            this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.detailChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchLevel = async (query) => {
        this.detailLevel.next({status: apiResponse.LOADING})
        await this.repository.fetchLevel(query).then((result) => {
            this.detailLevel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.detailLevel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchGenerateDocument = async (query) => {
        this.generateChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchGenerateDocument(query).then((result) => {
            this.generateChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.generateChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchGenerateUndanganSaksi = async (query) => {
        this.generateUndanganSaksiChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchGenerateUndanganSaksi(query).then((result) => {
            this.generateUndanganSaksiChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.generateUndanganSaksiChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchGenerateInvPegawai = async (query) => {
        this.generatePegawaiChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchGenerateInvPegawai(query).then((result) => {
            this.generatePegawaiChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.generatePegawaiChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchGenerateInvRohaniawan = async (query) => {
        this.generateRohaniawanChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchGenerateInvRohaniawan(query).then((result) => {
            this.generateRohaniawanChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.generateRohaniawanChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchGenerateDocumentSPMT = async (query) => {
        this.generateSPMTChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchGenerateDocumentSPMT(query).then((result) => {
            this.generateSPMTChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.generateSPMTChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchDetailDokpelantikan = async (query) => {
        this.docMenghadiriPelantikanChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDetailDokpelantikan(query).then((result) => {
            this.docMenghadiriPelantikanChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.docMenghadiriPelantikanChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchDetailDokUndanganSaksi = async (query) => {
        this.docSaksiChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDetailDokUndanganSaksi(query).then((result) => {
            this.docSaksiChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.docSaksiChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchDetailInvPegawai = async (query) => {
        this.invPegawaiChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDetailInvPegawai(query).then((result) => {
            this.invPegawaiChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.invPegawaiChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchDetailInvRohaniawan = async (query) => {
        this.invRohaniawanChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDetailInvRohaniawan(query).then((result) => {
            this.invRohaniawanChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.invRohaniawanChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchDetailDokSPMT = async (query) => {
        this.docSPMTChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDetailDokSPMT(query).then((result) => {
            this.docSPMTChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.docSPMTChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchInactive = async (query) => {
        this.inactiveChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchInactive(query).then((result) => {
            this.inactiveChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.inactiveChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
}

export default DetailBloc